import './SelectItemAdditionalInfo.scss';

import React from 'react';

interface SelectItemAdditionalInfoProps {
  additionalInfo: string;
}

const SelectItemAdditionalInfo = ({ additionalInfo }: SelectItemAdditionalInfoProps) => {
  return <span className="SelectItemAdditionalInfo">{` • ${additionalInfo}`}</span>;
};

export default SelectItemAdditionalInfo;
